import React from 'react'
import { NextImage } from '@/components/NextImage'
import { useImage } from '@/hooks/images/useImage'
import { useTranslation } from '@/localization/useTranslation'
import { IPlaylistItem } from '@/types'
import { CardEventInfo } from '@/components/Cards/utils/CardEventInfo'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock, faPlay } from '@fortawesome/free-solid-svg-icons'
import { Tooltip } from '@/components/Tooltip'

import classNames from 'classnames'
import classes from './styles.module.scss'

interface VerticalCardProps {
  item: IPlaylistItem
  imageCut?: string
  handleCardClick: (item: any) => void
  isPlaceholder: boolean
  isLocked?: boolean
}

export const VerticalCard = (props: VerticalCardProps) => {
  const {
    item,
    imageCut = 'mediumv',
    handleCardClick,
    isPlaceholder,
    isLocked = false,
  } = props
  const { t } = useTranslation()
  const event = item?.__belong?.Event
  const canPlay = !!item?.videos?.length
  const { url: image } = useImage({ images: item?.images, cut: imageCut, scale: '50' })

  const displayTitle = isPlaceholder ? '__placeholder__' : t(item.title)

  return (
    <div className={classes.card} onClick={() => handleCardClick(item)}>
      <div className={classes.body}>
        <div className={classNames({
          [classes.body__content]: true,
          [classes['body__content--can-play']]: canPlay,
          [classes['body__content--placeholder']]: isPlaceholder,
        })}>
          <NextImage
            alt={'test'}
            fill={true}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 20vw"
            src={image}
          />
          <CardEventInfo event={event} isLocked={isLocked} />
        </div>
        <Overlay isLocked={isLocked} canPlay={canPlay} />
      </div>
      <div className={classNames({
        [classes.title]: true,
        [classes['title--placeholder']]: isPlaceholder
      })}>
        <Tooltip
          text={displayTitle}
          position="bottom"
          disabled={isPlaceholder}
        >
          <h3>{displayTitle}</h3>
        </Tooltip>
      </div>
    </div>
  )
}

const Overlay = ({ isLocked, canPlay }: { isLocked: boolean, canPlay: boolean }) => {
  if (!canPlay && !isLocked) return null

  return (
    <div className={classNames({ [classes.overlay]: true })}>
      {isLocked ?
        <FontAwesomeIcon icon={faLock} size={'2x'} /> :
        <FontAwesomeIcon icon={faPlay} size={'2x'} />
      }
    </div>
  )
}